<div class="login-screen">   
    <div class="wrapper-reponsive">
        <!-- Start màn 3 -->
        <div class="content-box mt-2 mb-4 p-4">
            <div class="tlt-green-row mb-2">
                {{'STR_RESET_PASSWORD' | translate }}
            </div>
            <p class="p-2" style="white-space: pre-line;">
                {{'STR_NOTICE_RESET_PW'| translate}}                   
            </p>
            <div class="row-input row-input-auto-height p-4 mb-4">
                <div class="pl-3">
                    <div class="tlt-dot mb-1">{{'STR_NEW_PASSWORD'| translate}} </div>
                    <input (keydown)="removeErr($event, 1)" autocomplete="off" (paste)="onPaste($event)" [ngClass]="{'error-border': isErrFomart }" [(ngModel)]="passWord"  type="password" class="form-control mb-3" maxlength="16">
                    <div  *ngIf="isErrFomart" class="err-validate">
                        <span>{{strErrFomart | translate}}</span>
                    </div>
                    <div class="tlt-dot mb-1">{{'STR_CONFIRM_PASSWORD'| translate}}</div>
                    <input (keydown)="removeErr($event, 2)" autocomplete="off" (paste)="onPaste($event)" [ngClass]="{'error-border': isErrFomart2 }" [(ngModel)]="confirmPassword"  type="password" class="form-control mb-3" maxlength="16">
                    <div  *ngIf="isErrFomart2" class="err-validate">
                        <span>{{strErrFomart2 | translate}}</span>
                    </div>
                </div>
            </div>
            <div class="text-center mt-2">
                <button class="btn btn-common btn-bg-green" (click)="Reset()">
                    {{'STR_BTN_REGIS'| translate}}
                </button>
            </div>
        </div>
        <!-- End màn 3 -->
    </div>
</div>